module.exports = __webpack_public_path__ + "static/img/kmp869-663-39583.37743b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/kmp869-663-39583.jpg
// module id = MWW7
// module chunks = 0